import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-background">
        <div className="footer-gradient-orb"></div>
        <div className="footer-grid-pattern"></div>
      </div>
      
      <div className="footer-content">
        <div className="footer-main">
          {/* Connect With Us */}
          <div className="footer-section">
            <h4 className="footer-section-title">Connect With Us</h4>
            <div className="footer-links">
              <a href="https://www.linkedin.com/company/devroom-in" target="_blank" rel="noopener noreferrer" className="footer-link">
                <i className="fab fa-linkedin"></i>
                <span>LinkedIn</span>
              </a>
              <a href="https://x.com/DevroomI80567?t=c9YJlRI1OI5tPNvmObEM_A&s=08" target="_blank" rel="noopener noreferrer" className="footer-link">
                <i className="fab fa-twitter"></i>
                <span>Twitter</span>
              </a>
              <a href="https://www.instagram.com/devroom.in?igsh=MTdybHd3eW5zbnBqYQ==" target="_blank" rel="noopener noreferrer" className="footer-link">
                <i className="fab fa-instagram"></i>
                <span>Instagram</span>
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div className="footer-section">
            <h4 className="footer-section-title">Company</h4>
            <div className="footer-links">
              <Link to="/about" className="footer-link">
                <i className="fas fa-info-circle"></i>
                <span>About Us</span>
              </Link>
              <Link to="/team" className="footer-link">
                <i className="fas fa-users"></i>
                <span>Our Team</span>
              </Link>
              <Link to="/faq" className="footer-link">
                <i className="fas fa-question-circle"></i>
                <span>FAQ</span>
              </Link>
            </div>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h4 className="footer-section-title">Legal</h4>
            <div className="footer-links">
              <Link to="/privacy-policy" className="footer-link">
                <i className="fas fa-shield-alt"></i>
                <span>Privacy Policy</span>
              </Link>
              <Link to="/terms-of-service" className="footer-link">
                <i className="fas fa-file-contract"></i>
                <span>Terms of Service</span>
              </Link>
              <Link to="/feedback" className="footer-link">
                <i className="fas fa-comment-dots"></i>
                <span>Feedback</span>
              </Link>
            </div>
          </div>

          {/* Contact Us */}
          <div className="footer-section">
            <h4 className="footer-section-title">Contact Us</h4>
            <div className="footer-links">
              <a href="mailto:info@devroom.in" className="footer-link">
                <i className="fas fa-envelope"></i>
                <span>info@devroom.in</span>
                

              </a>
              <a href="mailto:info@devroom.in" className="footer-link">
                <i className="fas fa-envelope"></i>
                <span>support@devroom.in</span>
                

              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; 2025 DevRoom. All rights reserved.</p>
              <p className="footer-tagline">Building the future of collaborative development</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
